import script from "./selectCityPop.vue?vue&type=script&setup=true&lang=js"
export * from "./selectCityPop.vue?vue&type=script&setup=true&lang=js"

import "./selectCityPop.vue?vue&type=style&index=0&id=94e80c56&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94e80c56"]])

export default __exports__